export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于我们</h2>
            <p className="text-sm text-foreground-600 mt-1">了解人人影院的初心与使命</p>
          </div>

          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60">
            <div className="text-center mb-6">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/15 mb-4">
                <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
              </div>
              <h3 className="font-heading text-xl text-foreground-950">人人影院</h3>
              <p className="text-sm text-primary-500 mt-1">免费高清在线观看平台</p>
            </div>

            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                人人影院成立于2020年，致力于为广大影迷提供免费、高清、流畅的在线观影体验。我们深知追剧看片时缓冲卡顿的烦恼，
                因此投入大量资源优化播放技术，让每一位用户都能享受影院级的观看体验。
              </p>
              <p>
                平台目前汇聚超过<strong className="text-foreground-950">10万部</strong>影视资源，
                涵盖最新院线大片、热门电视剧全集、经典老片、高分纪录片和热门综艺。
                内容团队每日同步更新，确保用户第一时间看到最新内容。
              </p>
              <p>
                人人影院始终坚持<strong className="text-foreground-950">用户至上</strong>的原则：
                无需注册、完全免费、高清画质、多线路切换。未来我们将持续扩展片库，优化播放体验，
                努力成为华语地区最受欢迎的免费影视平台。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-xl font-bold text-primary-500">10万+</div>
                <div className="text-xs text-foreground-600 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-500">5000万+</div>
                <div className="text-xs text-foreground-600 mt-1">月活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-500">99.9%</div>
                <div className="text-xs text-foreground-600 mt-1">服务可用率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}